import { render, staticRenderFns } from "./SectionIntro.vue?vue&type=template&id=3a66dd24&scoped=true"
import script from "./SectionIntro.vue?vue&type=script&lang=ts"
export * from "./SectionIntro.vue?vue&type=script&lang=ts"
import style0 from "./SectionIntro.vue?vue&type=style&index=0&id=3a66dd24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a66dd24",
  null
  
)

export default component.exports